module.exports = "/static/assets/c5eb9014d85dac0da24506f2b203e68e.png";